import $ from 'jquery';
import config from '../config';
import _ from 'underscore';
const iframeMarkup = `<iframe src="about:blank" height="0" width="0" class="fc-third-party-iframe"></iframe>
<iframe src="about:blank" height="0" width="0" class="fc-third-party-iframe"></iframe>
<iframe src="about:blank" height="0" width="0" class="fc-third-party-iframe"></iframe>
<iframe src="about:blank" height="0" width="0" class="fc-third-party-iframe"></iframe>`;

/**
 *
 * @param action
 * @param cookies
 * @example thirdPartyCookies('setCookies', [{name: 'theme_ver', value: 2 }]);
 * @example thirdPartyCookies('removeCookies', [{name: 'theme_ver'}]);
 */
export default (action, cookies) => {
    const safari = (navigator.vendor !== null && navigator.vendor.match(/Apple Computer, Inc./) && navigator.userAgent.indexOf('Safari') !== -1);
    if (safari) {
        const $body = $('body');
        $body.append(iframeMarkup);

        const currentUrl = config.get('currentSiteUrl');
        let siteUrls = config.get('siteUrls');
        siteUrls = _.without(siteUrls, currentUrl);
        // This obviously would be nicer for promises, but we don't have them in slot-fc
        // when we only need to support redesign do this with promises (@mbenin)
        let processed = 0;
        const $iframes = $('.fc-third-party-iframe');

        const checkProcessed = () => {
            processed++;
            if (processed === siteUrls.length) {
                processed = 0;
                $iframes.remove();
            }
        };

        const setIframeSrc = function (index, el) {
            const $el = $(el);
            const origin = siteUrls[index];
            $el.attr('src', `http://${origin}/__/auth-iframe`);
            function loadedIframe() {
                $el.off('load', loadedIframe);
                const conf = {
                    action: action,
                    cookies: cookies,
                    parentUrl: `http://${currentUrl}`
                };

                function handleResponse(evt) {
                    var confResp;
                    try {
                        confResp = JSON.parse(evt.originalEvent.data);
                    } catch (err) {
                        confResp = {};
                    }
                    if (siteUrls.indexOf(confResp.childUrl) !== -1) {
                        $(window).off('message', handleResponse);
                        checkProcessed();
                        // console.log(`conf from child: ${JSON.stringify(confResp)}`); // eslint-disable-line no-console
                    }
                }

                $(window).on('message', handleResponse);

                this.contentWindow.postMessage(JSON.stringify(conf), `http://${origin}`);
            }

            $el.on('load', loadedIframe);
        };

        $iframes.each(setIframeSrc);
    }
};
